export default "__VITE_ASSET__Bh7cFfhP__"